import {
  HttpInterceptorFn,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
  HttpRequest,
  HttpHandler,
  HttpHandlerFn,
} from '@angular/common/http';
import { tap, catchError, switchMap } from 'rxjs/operators';
import { Observable, throwError, from } from 'rxjs';
import { LoggingService } from '../logging-service';
import { inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { session } from '../../common/session/session';
import { AuthService } from '../auth.service';
import { environment } from '../../../../environments/environment';
import { headers } from '../../common/headers';
import { Router } from '@angular/router';
import { LoaderService } from '../loader/loader.service';

const BASE_API_URL = `${environment.apiUrl}/api`;
const BASE_ONBOARDING_URL = `${environment.onboardingUrl}/api`;
const BASE_COMMON_LOOKUP_URL = `${environment.commonLookupUrl}/api`;
const Base_Ai_services_URL = `${environment.microserviceurl}/api`;

export const ApiInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {

  const logger = inject(LoggingService);
  const loadingService = inject(LoaderService);
  const cookiesService = inject(CookieService);
  const authService = inject(AuthService);
  const router = inject(Router);

  const ignoreUrls =['version.json','health-system.html'];

  if (req.url.includes('quicksight.obelogistics.com')) {
    return next(req);
  }

  logger.logInfo(`Outgoing HTTP Request: ${req.method} ${req.url}`);
 if (ignoreUrls.some(url => req.url.includes(url))) {
  return next(req);
 }

  let authToken = cookiesService.get(session.authToken);
  let userType = cookiesService.get(session.userType);
  let username = cookiesService.get(session.setEmail);
  let sesseionKeys = cookiesService.get(session.sessionId);

  // Check for custom header to determine which base URL to use
  let useOnboardingUrl = req.headers.get(headers.onboardingHeader) === 'true';
  let useCommonLookupUrl = req.headers.get(headers.lookupHeader) === 'true';
  let useAiServicesUrl = req.headers.get(headers.microservices) === 'true';

  // let baseUrl = useOnboardingUrl
  //   ? BASE_ONBOARDING_URL
  //   : useCommonLookupUrl
  //     ? BASE_COMMON_LOOKUP_URL
  //     : BASE_API_URL;
  let baseUrl = resolveBaseUrlDynamic(req);

  //removing headers
  for (const key of Object.keys(headers)) {
    const headerName = headers[key as keyof typeof headers];
    
     if (
      headerName === headers.schedulingMasterHeaderLogistic &&
      req.headers.has(headers.schedulingMasterHeaderLogistic)
    ) {
      continue;
    }

    if (req.headers.has(headerName)) {
      req = req.clone({ headers: req.headers.delete(headerName) });
    }
  }

  if (!req.url.startsWith('http')) {
    req = req.clone({ url: `${baseUrl}/${req.url}` });
  }

  if (authToken) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${authToken}`,
      },
    });
  }

  if (userType) {
    req = req.clone({
      setHeaders: {
        userType: userType,
      },
    });
  }
  if (username) {
    req = req.clone({
      setHeaders: {
        username: username,
      },
    });
  }
  if (sesseionKeys) {
    req = req.clone({
      setHeaders: {
        sesseionId: sesseionKeys,
      },
    });
  }

  return next(req).pipe(
    tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // logger.logInfo(`Incoming HTTP Response: ${event.status} ${req.url}`);
        // logger.logInfo(`Response Body: ${JSON.stringify(event.body)}`);
      }
    }),
    catchError((error: any) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        // Navigate to home on 401
        router.navigate(['/']);
        loadingService.resetSpinner();
      }
      loadingService.resetSpinner();
      return throwError(() => error);
    }),
  );
};
export function resolveBaseUrlDynamic(req: any): string {
  for (const key of Object.keys(headers)) {
    const headerName = headers[key as keyof typeof headers];
    const headerValue = req.headers.get(headerName);

    if (headerValue?.toLowerCase() === 'true') {
      switch (headerName) {
        case headers.onboardingHeader:
          return `${environment.onboardingUrl}/api`;
        case headers.lookupHeader:
          return `${environment.commonLookupUrl}/api`;
        case headers.demoHeader:
          return `${environment.demoUrl}/api`;
        case headers.careManagerHeader:
          return `${environment.careManagerPortalUrl}/api`;
        case headers.microservices:
          return `${environment.microserviceurl}/api`;
        case headers.logisticHeader:
          return `${environment.logisticUrl}/api`;
        case headers.twilioHeader:
          return `${environment.twilioUrl}/api`;
        case headers.ragHeader:
          return `${environment.ragUrl}`;
        case headers.demoNewHeader:
          return `${environment.demoNew}`;
        case headers.doctorHeader:
          return `${environment.doctorUrl}/api`;
            case headers.billingHeader:
          return `${environment.billingUrl}/api`;
      }
    }
  }

  return BASE_API_URL;
}
